/**
 * App color themes
 * @module themeColors
 */

const themeColors = {
  red: {
    primary: ['red', 'darken-4'].join(' '),
    primaryText: ['red--text'].join('')
  },
  green: {
    primary: ['green', 'darken-4'].join(' '),
    primaryText: ['green--text'].join('')
  },
  purple: {
    primary: ['purple', 'darken-4'].join(' '),
    primaryText: ['purple--text'].join('')
  },
  indigo: {
    primary: ['indigo', 'darken-4'].join(' '),
    primaryText: ['indigo--text'].join('')
  },
  orange: {
    primary: ['orange', 'darken-4'].join(' '),
    primaryText: ['orange--text'].join('')
  },
  black: {
    primary: ['black', 'darken-4'].join(' '),
    primaryText: ['black--text'].join('')
  }
}

export default themeColors



// WEBPACK FOOTER //
// ./src/helpers/theme-colors.js